import {useMemo} from 'react'

/**
 * Hook to parse and organize Optimizely CMS content for cart page
 * Separates different block types into their respective rendering locations
 *
 * @param {Object} optimizelyData - Raw Optimizely data from fetchData
 * @returns {Object} Organized CMS content by location
 */
export const useCartCMSContent = (optimizelyData) => {
    return useMemo(() => {
        if (!optimizelyData?.items?.[0]?.MainRegion) {
            return {
                banners: [],
                carousels: [],
                emptyMessage: null
            }
        }

        const mainRegion = optimizelyData.items[0].MainRegion
        const banners = []
        const carousels = []
        let emptyMessage = null

        mainRegion.forEach((item) => {
            const block = item.ContentLink?.Expanded
            if (!block) return

            switch (block.__typename) {
                case 'CategoryBannerBlock':
                    banners.push(block)
                    break
                case 'VickyProductCarouselBlock':
                    carousels.push(block)
                    break
                case 'SearchEmptyMessageBlock':
                    emptyMessage = block
                    break
                // Skip CheckoutContactUsTextBlock - will be in global elements
                case 'CheckoutContactUsTextBlock':
                    break
                default:
                    console.warn(`Unknown cart CMS block type: ${block.__typename}`)
            }
        })

        return {
            banners,
            carousels,
            emptyMessage
        }
    }, [optimizelyData])
}
